// Game user POST API endpoints
export const GAME_USER_POST_APIS = {
    CREATE_GAME_USER: 'create_game_user',
    BUY_PRODUCTS: 'buy_products',
    HIRE_EMPLOYEE: 'hire_employee',
    FIRE_EMPLOYEE: 'fire_employee',
    LEASE_WAREHOUSE: 'lease_warehouse',
    UNLEASE_WAREHOUSE: 'unlease_warehouse',
    LEASE_CAR: 'lease_car',
    UNLEASE_CAR: 'unlease_car',
    SAVE_MESSAGE: 'save_message',
    SUBMIT_FINANCIAL_STATEMENTS: 'submit_financial_statements',
    SUBMIT_FINANCIAL_RATIOS: 'submit_financial_ratios',
    RELOAD_CHECKPOINT: 'reload_checkpoint',
    CREATE_GAME_USER_FROM_CHECKPOINT: 'create_game_user_from_checkpoint',
};

// Game user PATCH API endpoints
export const GAME_USER_PATCH_APIS = {
    MARK_MESSAGE_AS_SEEN: 'mark_message_as_seen',
    UPDATE_STORE_NAME: 'update_store_name',
    UPDATE_LEVEL: 'update_level',
    UPDATE_TURN: 'update_turn',
    SELL_PRODUCT: 'sell_product',
    UPDATE_SELLING_PRICES: 'update_selling_prices',
    UPDATE_LOGBOOK: 'update_logbook',
    SAVE_TRADESHOW_SALES_LOG: 'save_tradeshow_sales_log',
    UPDATE_FINANCIAL_STATEMENTS_FIELD: 'update_financial_statements_field',
    UPDATE_DISTRIBUTED_PROFITS: 'update_distributed_profits',
    UPDATE_PLAYER_HEALTH: 'update_player_health',
    UPDATE_CASH: 'update_cash',
};

// Running ads POST API endpoints
export const RUNNING_ADS_POST_APIS = {
    HIRE_AD: 'hire_ad',
};

// Running ads PATCH
export const RUNNING_ADS_PATCH_APIS = {
    STOP_RUNNING_AD: 'stop_running_ad',
};

// Tradeshow POST API endpoints
export const TRADESHOWS_POST_APIS = {
    HIRE_TRADESHOW: 'hire',
};

// Characters PUT API endpoints
export const CHARACTERS_PUT_APIS = {
    UPDATE_CHARACTER: 'update_character',
};

// Warehouse GET/POST endpoints (utility)
export const WAREHOUSE_APIS = {
    GET_ALL: 'warehouses',
    LEASE: 'lease_warehouse',
    UNLEASE: 'unlease_warehouse',
    LEASED_LIST: 'leased_warehouses',
};

// Car endpoints
export const CAR_APIS = {
    GET_ALL: 'cars',
    LEASE: 'lease_car',
    UNLEASE: 'unlease_car',
    LEASED_LIST: 'leased_cars',
};

// Store endpoints
export const STORE_APIS = {
    GET_ALL: 'stores',
};

// Employee endpoints
export const EMPLOYEE_APIS = {
    GET_ALL: 'employees',
    HIRE: 'hire_employee',
    FIRE: 'fire_employee',
    HIRED_LIST: 'hired_employees',
};

// Inbox endpoints
export const INBOX_APIS = {
    GET_MESSAGES: 'messages',
    MARK_SEEN: 'mark_message_as_seen',
};

// Level endpoints
export const LEVEL_APIS = {
    UPDATE_LEVEL: 'update_level',
    LOAD_LEVEL: 'level' // maybe not needed
};

// Central NON_RETRY_REQUESTS array:
export const NON_RETRY_REQUESTS = [
    GAME_USER_POST_APIS.CREATE_GAME_USER,
    GAME_USER_POST_APIS.BUY_PRODUCTS,
    GAME_USER_PATCH_APIS.UPDATE_SELLING_PRICES,
    GAME_USER_PATCH_APIS.UPDATE_FINANCIAL_STATEMENTS_FIELD,
];
